import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { Router } from '@angular/router';
import { LoaderService } from '../../services/Spinner.service';
import { FormGroup, FormControl, Validators, FormBuilder ,AbstractControl} from '@angular/forms';
import { ValidationService } from '../../services/validation.service';
import { LocalStorage } from '../../services/local-storage';
import { PasswordValidation } from '../shared/components/password-validation';
import { ControlMessagesComponent } from '../shared/components/control-messages.component';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupSegmentComponent } from '../shared/components/popupAdmin/popup-segment.component';
import { IMyDpOptions, IMyDate, IMyDateModel } from 'mydatepicker';
@Component({

  selector: 'app-settings',
  templateUrl: './settings.component.html',
 // styleUrls: ['./updatepassword.component.css'],
  providers :[LocalStorage,SharedService,PopupSegmentComponent]
})
export class SettingsComponent implements OnInit {
  objLoaderStatus: boolean = false;
  campaignEndDate : Object = {};
  settingForm: FormGroup;
  successMsg : boolean;
  errorMsg : string;
  settingsData : any = {};
  selectedDate:any = { date: { year: 2018, month: 10, day: 9 } };
  // campaign.campaignStartDate = "";

  myDatePickerOptions: IMyDpOptions = {
      // other options...
      dateFormat: 'dd, mmm, yyyy',
      alignSelectorRight: true,
      showTodayBtn: false
  };

  constructor(private localstorage : LocalStorage,private formBuilder: FormBuilder, private router: Router,private shareService :SharedService, private loaderService: LoaderService,private PopupSegment: PopupSegmentComponent, 
    private dialogService:DialogService) { 
      // this.selectedDate = {year: 2016, month: 12, day: 26};
  }
  ngOnInit() {
      this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
    let body = document.getElementsByTagName('body')[0];
    body.classList.remove("zizbackground");
    body.classList.remove("overflow");

    this.successMsg=false;
    this.errorMsg='';
    this.settingForm = this.formBuilder.group({
      campaignEndDate: [''],
      deviceToken: ["AQDX124324"],
      loginFlg: ['false']
    });
    this.getSettings();
  }
  
  onSubmit() {
    
    if(this.settingForm.value.campaignEndDate.date){
      //this.settingForm.value.confirmPass=this.settingForm.value.confirmpassword;
      let month = this.settingForm.value.campaignEndDate.date.month<10?"0"+this.settingForm.value.campaignEndDate.date.month:this.settingForm.value.campaignEndDate.date.month;
      let date = this.settingForm.value.campaignEndDate.date.year + "-" + month + "-" + this.settingForm.value.campaignEndDate.date.day;
      var settingData = {
                "campaignEndDate": date
            }
      var token=this.localstorage.getStorage('token');
      this.loaderService.displayLoader(true);
      this.shareService.callApiWithToken("admin/updateSettings",settingData,token).subscribe((result) => {
        if(result.data) {
          // this.localstorage.setStorage('token',result.data.token);
          this.successMsg=true;
          // this.showUpdate();
          this.loaderService.displayLoader(false);
          this.getSettings();
        }  
      });
    }
  }

  showUpdate() {
    let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
    title:'Account Information', 
    message:"Setting has been updated Successfully",
    data: [],
    showcancel : false})
    .subscribe((isConfirmed)=>{
      this.router.navigate(['admin/users']);
    });
  }

  getSettings(){
    var token=this.localstorage.getStorage('token');
    this.shareService.CallDatawithToken("admin/getAdminSettings",'',token).subscribe((result) => {
      if(result.data) {
        this.settingsData = result.data;
        this.settingForm.patchValue({
            campaignEndDate: {
              jsdate: new Date(result.data.campaignEndDate)
            }
        });
        this.loaderService.displayLoader(false);
      }  
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/settings/settings.component.ts